/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PortfolioBasicLegalType = "HIDDEN" | "PX_PROVIDED" | "%future added value";
export type PortfolioStatus = "ACTIVE" | "INACTIVE" | "ONBOARDING" | "%future added value";
export type PortfolioThemeAppearance = "DARK" | "LIGHT" | "%future added value";
export type PortfolioThemeAssetSize = "ORIGINAL" | "%future added value";
export type PortfolioThemeColour = "ACCENT_ASH" | "ACCENT_BLUE" | "ACCENT_GOLD" | "ACCENT_MONO" | "ACCENT_ORANGE" | "ACCENT_TEAL" | "ACCENT_VIOLET" | "BORDER" | "%future added value";
export type PortfolioThemeFont = "ALEO" | "INTER" | "PT_SERIF" | "%future added value";
export type PortfolioVisibility = "HIDDEN" | "VISIBLE" | "%future added value";
export type PortfolioQueryRendererQueryVariables = {|
  domain: string
|};
export type PortfolioQueryRendererQueryResponse = {|
  +portfolio: ?{|
    +id: string,
    +legacyId: string,
    +status: PortfolioStatus,
    +title: string,
    +description: string,
    +email: ?string,
    +font: PortfolioThemeFont,
    +colour: PortfolioThemeColour,
    +appearance: PortfolioThemeAppearance,
    +deactivatedMessage: ?string,
    +socialMedia: ?{|
      +twitter: ?string,
      +instagram: ?string,
      +facebook: ?string,
    |},
    +location: ?{|
      +city: ?string,
      +country: ?string,
    |},
    +user: {|
      +id: string,
      +username: ?string,
    |},
    +termsOfUse: {|
      +type?: PortfolioBasicLegalType,
      +url?: string,
    |},
    +privacyPolicy: {|
      +type?: PortfolioBasicLegalType,
      +url?: string,
    |},
    +coverPhoto: {|
      +images?: $ReadOnlyArray<{|
        +legacyId: string,
        +size: number,
        +url: string,
      |}>,
      +avatar?: {|
        +images: ?$ReadOnlyArray<?{|
          +url: string
        |}>
      |},
      +photo?: {|
        +id: string,
        +urls: {|
          +size_1024: string,
          +size_2048: string,
        |},
      |},
    |},
    +theme: {|
      +name: string,
      +description: string,
      +imageUrls: $ReadOnlyArray<{|
        +size: ?PortfolioThemeAssetSize,
        +url: string,
      |}>,
    |},
    +visibilityOptions: {|
      +location: PortfolioVisibility,
      +pxProfile: PortfolioVisibility,
      +instagram: PortfolioVisibility,
      +facebook: PortfolioVisibility,
      +twitter: PortfolioVisibility,
    |},
    +folders: $ReadOnlyArray<?{|
      +id: string,
      +name: string,
      +description: ?string,
      +coverPhoto: ?{|
        +id: string,
        +title: ?string,
        +width: number,
        +height: number,
        +urls: {|
          +size_600: string,
          +size_1024: string,
          +size_2048: string,
        |},
      |},
      +photos: {|
        +edges: $ReadOnlyArray<{|
          +node: {|
            +id: string,
            +title: ?string,
            +description: ?string,
            +width: number,
            +height: number,
            +urls: {|
              +size_600: string,
              +size_1024: string,
              +size_2048: string,
            |},
          |}
        |}>
      |},
    |}>,
    +analyticsCode: ?string,
  |}
|};
export type PortfolioQueryRendererQuery = {|
  variables: PortfolioQueryRendererQueryVariables,
  response: PortfolioQueryRendererQueryResponse,
|};
*/


/*
query PortfolioQueryRendererQuery(
  $domain: String!
) {
  portfolio: getPortfolioByDomain(domain: $domain) {
    id
    legacyId
    status
    title
    description
    email
    font
    colour
    appearance
    deactivatedMessage
    socialMedia {
      twitter
      instagram
      facebook
    }
    location {
      city
      country
    }
    user {
      id
      username
    }
    termsOfUse {
      __typename
      ... on PortfolioBasicLegalSettings {
        type
      }
      ... on PortfolioCustomLegalSettings {
        url
      }
    }
    privacyPolicy {
      __typename
      ... on PortfolioBasicLegalSettings {
        type
      }
      ... on PortfolioCustomLegalSettings {
        url
      }
    }
    coverPhoto {
      __typename
      ... on PortfolioCoverImage {
        images(sizes: [1024, 2048]) {
          legacyId
          size
          url
          id
        }
      }
      ... on PortfolioCoverAvatar {
        avatar {
          images(sizes: [COVER]) {
            url
            id
          }
          id
        }
      }
      ... on PortfolioCoverPhoto {
        photo {
          id
          urls {
            size_1024
            size_2048
          }
        }
      }
    }
    theme {
      name
      description
      imageUrls {
        size
        url
      }
      id
    }
    visibilityOptions {
      location
      pxProfile
      instagram
      facebook
      twitter
    }
    folders {
      id
      name
      description
      coverPhoto {
        id
        title
        width
        height
        urls {
          size_600
          size_1024
          size_2048
        }
      }
      photos(first: 100) {
        edges {
          node {
            id
            title
            description
            width
            height
            urls {
              size_600
              size_1024
              size_2048
            }
          }
        }
      }
    }
    analyticsCode
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "domain"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "domain",
    "variableName": "domain"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legacyId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "font",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colour",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appearance",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deactivatedMessage",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitter",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instagram",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facebook",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "PortfolioSocialMedia",
  "kind": "LinkedField",
  "name": "socialMedia",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "PortfolioLocation",
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "PortfolioBasicLegalSettings",
  "abstractKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "kind": "InlineFragment",
  "selections": (v20/*: any*/),
  "type": "PortfolioCustomLegalSettings",
  "abstractKey": null
},
v22 = [
  (v18/*: any*/),
  (v21/*: any*/)
],
v23 = [
  {
    "kind": "Literal",
    "name": "sizes",
    "value": [
      1024,
      2048
    ]
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v25 = [
  {
    "kind": "Literal",
    "name": "sizes",
    "value": [
      "COVER"
    ]
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size_1024",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size_2048",
  "storageKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "photo",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotoUrls",
          "kind": "LinkedField",
          "name": "urls",
          "plural": false,
          "selections": [
            (v26/*: any*/),
            (v27/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PortfolioCoverPhoto",
  "abstractKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "PortfolioThemeAsset",
  "kind": "LinkedField",
  "name": "imageUrls",
  "plural": true,
  "selections": [
    (v24/*: any*/),
    (v19/*: any*/)
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "PortfolioVisibilityOptions",
  "kind": "LinkedField",
  "name": "visibilityOptions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pxProfile",
      "storageKey": null
    },
    (v13/*: any*/),
    (v14/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "PhotoUrls",
  "kind": "LinkedField",
  "name": "urls",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "size_600",
      "storageKey": null
    },
    (v26/*: any*/),
    (v27/*: any*/)
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Folder",
  "kind": "LinkedField",
  "name": "folders",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v29/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "coverPhoto",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v5/*: any*/),
        (v32/*: any*/),
        (v33/*: any*/),
        (v34/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "PhotoConnection",
      "kind": "LinkedField",
      "name": "photos",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotoEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Photo",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v32/*: any*/),
                (v33/*: any*/),
                (v34/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "photos(first:100)"
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "analyticsCode",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v38 = [
  (v37/*: any*/),
  (v18/*: any*/),
  (v21/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioQueryRendererQuery",
    "selections": [
      {
        "alias": "portfolio",
        "args": (v1/*: any*/),
        "concreteType": "Portfolio",
        "kind": "LinkedField",
        "name": "getPortfolioByDomain",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "termsOfUse",
            "plural": false,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "privacyPolicy",
            "plural": false,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "coverPhoto",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v23/*: any*/),
                    "concreteType": "PortfolioCoverResizeImage",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v24/*: any*/),
                      (v19/*: any*/)
                    ],
                    "storageKey": "images(sizes:[1024,2048])"
                  }
                ],
                "type": "PortfolioCoverImage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v25/*: any*/),
                        "concreteType": "UserAvatarResizeImage",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": (v20/*: any*/),
                        "storageKey": "images(sizes:[\"COVER\"])"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "PortfolioCoverAvatar",
                "abstractKey": null
              },
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PortfolioTheme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              (v6/*: any*/),
              (v30/*: any*/)
            ],
            "storageKey": null
          },
          (v31/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PortfolioQueryRendererQuery",
    "selections": [
      {
        "alias": "portfolio",
        "args": (v1/*: any*/),
        "concreteType": "Portfolio",
        "kind": "LinkedField",
        "name": "getPortfolioByDomain",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "termsOfUse",
            "plural": false,
            "selections": (v38/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "privacyPolicy",
            "plural": false,
            "selections": (v38/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "coverPhoto",
            "plural": false,
            "selections": [
              (v37/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v23/*: any*/),
                    "concreteType": "PortfolioCoverResizeImage",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v24/*: any*/),
                      (v19/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": "images(sizes:[1024,2048])"
                  }
                ],
                "type": "PortfolioCoverImage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v25/*: any*/),
                        "concreteType": "UserAvatarResizeImage",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": [
                          (v19/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": "images(sizes:[\"COVER\"])"
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "PortfolioCoverAvatar",
                "abstractKey": null
              },
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PortfolioTheme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              (v6/*: any*/),
              (v30/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v31/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d1806d93ff3a0594112eb4ca4bfb2e88",
    "id": null,
    "metadata": {},
    "name": "PortfolioQueryRendererQuery",
    "operationKind": "query",
    "text": "query PortfolioQueryRendererQuery(\n  $domain: String!\n) {\n  portfolio: getPortfolioByDomain(domain: $domain) {\n    id\n    legacyId\n    status\n    title\n    description\n    email\n    font\n    colour\n    appearance\n    deactivatedMessage\n    socialMedia {\n      twitter\n      instagram\n      facebook\n    }\n    location {\n      city\n      country\n    }\n    user {\n      id\n      username\n    }\n    termsOfUse {\n      __typename\n      ... on PortfolioBasicLegalSettings {\n        type\n      }\n      ... on PortfolioCustomLegalSettings {\n        url\n      }\n    }\n    privacyPolicy {\n      __typename\n      ... on PortfolioBasicLegalSettings {\n        type\n      }\n      ... on PortfolioCustomLegalSettings {\n        url\n      }\n    }\n    coverPhoto {\n      __typename\n      ... on PortfolioCoverImage {\n        images(sizes: [1024, 2048]) {\n          legacyId\n          size\n          url\n          id\n        }\n      }\n      ... on PortfolioCoverAvatar {\n        avatar {\n          images(sizes: [COVER]) {\n            url\n            id\n          }\n          id\n        }\n      }\n      ... on PortfolioCoverPhoto {\n        photo {\n          id\n          urls {\n            size_1024\n            size_2048\n          }\n        }\n      }\n    }\n    theme {\n      name\n      description\n      imageUrls {\n        size\n        url\n      }\n      id\n    }\n    visibilityOptions {\n      location\n      pxProfile\n      instagram\n      facebook\n      twitter\n    }\n    folders {\n      id\n      name\n      description\n      coverPhoto {\n        id\n        title\n        width\n        height\n        urls {\n          size_600\n          size_1024\n          size_2048\n        }\n      }\n      photos(first: 100) {\n        edges {\n          node {\n            id\n            title\n            description\n            width\n            height\n            urls {\n              size_600\n              size_1024\n              size_2048\n            }\n          }\n        }\n      }\n    }\n    analyticsCode\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8ccdaa20c5b7f81876b39f2252c9e69b';

module.exports = node;
